import type { ReactNode } from "react"

export type ButtonHintProps = {
  /** One-line action summary, e.g. "Publish — go live in this environment". */
  title: string
  /** What actually happens — and, when easily confused, what does NOT. */
  children: ReactNode
}

/**
 * Two-line tooltip content for action buttons whose short labels need
 * disambiguation (e.g. Publish vs Push prod): a bold action summary over a
 * longer description. Pass as the `content` of a Tooltip/ConfirmButton.
 * Colors are relative to the tooltip shell, which is inverted
 * (`bg-foreground text-background`).
 */
function ButtonHint(props: ButtonHintProps) {
  const { title, children } = props

  return (
    <span className="flex max-w-64 flex-col gap-1 py-0.5 text-left">
      <span className="font-semibold">{title}</span>
      <span className="text-xs opacity-80">{children}</span>
    </span>
  )
}

export default ButtonHint
